(function (upp) {
    'use strict';

    /**
     * Check p is a promise
     * FIXME: this is not so bulletproof, any object that has a then method will be identified as a promise
     * @param {*} p p is the "thing" we want to check
     * @return {Boolean} is it a promise?
     */
    var isPromise = function (p) {
        return typeof p.then === 'function';
    };

    upp.controller('upp.calendar.BookCtrl', ['calendarService', '$routeParams', 'calendarUtil', 'appi', '$scope', 'storage', '$timeout',
        function (calendarService, $routeParams, calendarUtil, appi, $scope, storage, $timeout) {
            appi.ui.changeActualOption({moduleKey2Display: 'booking', navbarKey: 'booking'});
            appi.ui.showPageLoadingMsg();

            var calendarSelected = $routeParams.calendarId;

            /**
             * Data for the reservation form
             */
            $scope.reservation = {
                attendants: 1,
                comments: '',
                intervalSelected: ''
            };

            $scope.calendar = 0;
            $scope.url = '';
            $scope.isExternal = false;

            calendarService.getConfig().then(function(data) {

                if (data.hasOwnProperty('external')) {
                    $scope.isExternal = data.external;
                }
                else {
                    $scope.isExternal = false;
                }

                if (!data.external) {
                   $scope.calendars = data.calendars;

                   if (storage.get('bookingDate')) {
                       $scope.dateSelected = JSON.parse(storage.get('bookingDate'));
                   }

                   if ($scope.calendars.length > 0) {

                       if ($scope.calendars.length === 1 || calendarSelected > 0) {
                           $scope.calendar = calendarSelected || $scope.calendars[0].id;
                       }

                       $scope.selectCalendar($scope.calendar);

                       /**
                        * FIXME
                        * Template is rendered after setting the reservation values so the value of
                        * the inputs is not updated. This is needed to set the default information.
                        */
                       $timeout(function () {
                           $scope.reservation.attendants = Number(storage.get('bookingNumPersons')) || 1;
                           $scope.reservation.comments = storage.get('bookingComments') || '';
                       }, 500);
                   }
                } else {
                    $scope.url = data.url;
                }

                appi.ui.hidePageLoadingMsg();

            }, function () {
                appi.ui.showNetworkError();
            });


            var today = new Date();

            /**
             * Date context to track the day, month and year that is currently selected
             * @type {{day: number, month: number, year: number}}
             */
            $scope.dateSelected = {
                day: today.getUTCDate(),
                month: today.getUTCMonth(),
                year: today.getUTCFullYear()
            };

            /**
             * Resets the page settings
             * @param $scope
             * @private
             */
            var _resetPageSettings = function ($scope) {
                $scope.events = [];
                $scope.errorName = '';
                $scope.reservation = {
                    attendants: 1
                };
            };

            $scope.events = [];

            $scope.calendarData = calendarUtil.generateMonth();

            /**
             * Updates the date context
             * @param $scope Current scope
             * @param {*} date The date
             * @private
             */
            var _updateDateContext = function ($scope, date) {
                $scope.dateSelected = date;
                _resetPageSettings($scope);
            };

            /**
             * Reload month listener
             */
            $scope.$on('calendar:reloadMonth', function (event, date) {
                $scope.reservation.intervalSelected = '';
                _updateDateContext($scope, date);

                var result = calendarService.getMonthlyCalendar($scope.calendar, $scope.dateSelected);
                if (isPromise(result)) {
                    result.then(function (calendar) {
                        $scope.calendarData = calendar;
                    }, function () {
                        appi.ui.showNetworkError();
                    });
                } else {
                    $scope.calendarData = result;

                    appi.ui.hidePageLoadingMsg();
                }
            });

            /**
             * Day selected listener. Is triggered when the user selects a day
             */
            $scope.$on('calendar:daySelected', function (event, date) {
                _updateDateContext($scope, date);

                appi.ui.showPageLoadingMsg();

                calendarService.getIntervals($scope.calendar, $scope.dateSelected)
                    .then(function (events) {
                        $scope.events = events;

                        $scope.reservation.intervalSelected = Number(storage.get('bookingIntervalId')) || '';
                        $scope.selectInterval($scope.reservation.intervalSelected);
                        appi.ui.hidePageLoadingMsg();
                    }, function () {
                        appi.ui.showNetworkError();
                    });
            });

            /**
             * Change the calendar, so we load the new url
             * @param calendarId number
             */
            $scope.changeCalendar = function (calendarId) {
                if (calendarId && !isNaN(calendarId))
                    appi.location.path('/booking/' + calendarId);
            };


            /**
             * When a calendar is selected load the monthly view of the calendar
             * @param {string} calendarId
             */
            $scope.selectCalendar = function (calendarId) {

                $scope.reservation.intervalSelected = '';
                var cal = Number(calendarId);

                if (!isNaN(cal) && cal > 0) {
                    $scope.calendar = cal;

                    for (var i = 0; i < $scope.calendars.length; i++) {
                        var c = $scope.calendars[i];

                        if (c.id === cal) {
                            $scope.calendarContext = c;
                        }
                    }

                    appi.ui.showPageLoadingMsg();

                    var result = calendarService.getMonthlyCalendar(cal, $scope.dateSelected);
                    if (isPromise(result)) {
                        result.then(function (calendar) {
                            $scope.calendarData = calendar;

                            appi.ui.hidePageLoadingMsg();
                            $scope.$emit('calendar:daySelected', $scope.dateSelected);
                        }, function () {
                            appi.ui.showNetworkError();
                        });
                    } else {
                        $scope.calendarData = result;

                        appi.ui.hidePageLoadingMsg();
                        $scope.$emit('calendar:daySelected', $scope.dateSelected);
                    }
                }
            };

            /**
             * Selects an interval
             * @param {Object} event
             */
            $scope.selectInterval = function (event) {
                if (Array.isArray($scope.events)) {
                    $scope.events.forEach(function (e) {
                        if (e.id === Number(event)) {
                            $scope.event = e;
                        }
                    });
                }
            };

            /**
             * Make a reservation
             */
            $scope.makeReservation = function () {
                // we store this info to redirect to the concrete reservation after login
                // if the user is not logged
                storage.set('redirectToBookings', 'true');
                storage.set('bookingIntervalId', $scope.reservation.intervalSelected);
                storage.set('bookingNumPersons', $scope.reservation.attendants);
                storage.set('bookingComments', $scope.reservation.comments);
                storage.set('bookingDate', JSON.stringify($scope.dateSelected));
                storage.set('bookingCalendar', $scope.calendar);

                appi.security.securable({scope: $scope})
                    .then(function (auth) {
                        if (auth.username !== undefined) {
                            var keysToDelete = ['redirectToBookings', 'bookingDate', 'bookingIntervalId',
                                'bookingNumPersons', 'bookingComments', 'bookingCalendar'];

                            for (var i = 0, len = keysToDelete.length; i < len; i++) {
                                storage.remove(keysToDelete[i]);
                            }

                            var data = angular.extend(angular.copy($scope.reservation), $scope.dateSelected);
                            // to allow reservations in different timezones
                            data.offsetMinutes = new Date().getTimezoneOffset();

                            appi.ui.showPageLoadingMsg();

                            calendarService.makeReservation(data)
                                .then(function (response) {
                                    $scope.errorName = response.message;

                                    appi.ui.hidePageLoadingMsg();

                                    if (response.message === 'SUCCESS') {
                                        _resetPageSettings($scope);

                                        appi.location.path('/calendar/success');
                                    } else if (response.message === 'EVENT_PAST') {
                                        $scope.eventPastError = true;
                                    }
                                }, function () {
                                    appi.ui.showNetworkError();
                                });
                        }
                    });
            };
        }]);

    upp.controller('upp.calendar.MyBookingsCtrl', ['$scope', 'bookingsService', 'appi',
        function ($scope, bookingsService, appi) {
            appi.security.securable({scope: $scope})
                .then(function () {
                    appi.ui.changeActualOption({i18n: 'BOOKINGS.MENU'});
                    appi.ui.showPageLoadingMsg();

                    /**
                     * Retrieve calendars
                     */
                    bookingsService.listCalendars()
                        .then(function (calendars) {
                            $scope.calendars = calendars;
                            $scope.calendarSelected = '';
                        }, function () {
                            appi.ui.showNetworkError();
                        });

                    /**
                     * Retrieve bookings
                     */
                    bookingsService.listBookings()
                        .then(function (bookings) {
                            $scope.loaded = true;
                            $scope.bookings = bookings;

                            $scope.bookings.map(function(book) {
                                book.date = new Date(book.date);
                                return book;
                            });

                            appi.ui.hidePageLoadingMsg();

                            $scope.openDetail = function (booking) {
                                booking.showDetail = !booking.showDetail;
                            };
                        }, function () {
                            appi.ui.showNetworkError();
                        });

                    /**
                     * Cancels a booking
                     * @param booking
                     */
                    $scope.cancelBooking = function (booking) {
                        appi.ui.showPageLoadingMsg();

                        bookingsService.cancelBooking(booking.id)
                            .then(function (message) {
                                appi.ui.hidePageLoadingMsg();

                                if (message === 'SUCCESS') {
                                    booking.status = 3;
                                }
                            }, function () {
                                appi.ui.showNetworkError();
                            });
                    }

                });
        }]);
})(upp);



// WEBPACK FOOTER //
// ./src/app/modules/booking/controllers/booking-controllers.js